import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.timers.js";
var state = reactive({
  toasts: []
});
export function useToaster() {
  /**
   * Show a toast message with the given config
   *
   * @param      {ToastMessage}  message           The message
   * @param      {number}        duration         The duration
   */
  function show(message, duration) {
    message._id = Date.now().toString();
    message.isFlash = !!duration;
    state.toasts.push(message);
    if (duration !== undefined) {
      startToastTimer(message._id, duration);
    }
  }

  /**
   * Starts a toast timer.
   *
   * @param      {string}  id        The toast id
   * @param      {number}  duration  The duration
   */
  function startToastTimer(id, duration) {
    setTimeout(function () {
      return close(id);
    }, duration);
  }

  /**
   * Close the given toast
   *
   * @param      {string}  id      The toast id
   */
  function close(id) {
    var index = state.toasts.findIndex(function (toast) {
      return toast._id === id;
    });
    if (index !== -1) state.toasts.splice(index, 1);
  }

  /**
   * Clears the toasts.
   */
  function clear() {
    state.toasts = [];
  }
  var toasts = computed(function () {
    return state.toasts;
  });
  return {
    show: show,
    close: close,
    clear: clear,
    toasts: toasts
  };
}